import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { MainLayout } from 'views/layouts'
import {
  Card,
  CardDescriptionSection,
  CardIconSection,
  CardTitle,
  Icon,
  ModuleAction,
  ModuleCardLink,
  ModulesContainer,
  ModulesPageHeader,
  ModuleSection,
  SectionTitle,
} from './styled'
import brainImage from 'assets/images/icon-betesa-card.png'
import boxImage from 'assets/images/icon-skills-card.png'
import Generales from '../../components/assets/generales.png'
import Familia from '../../components/assets/rolFamily.png'
import { superAdminRoutes } from 'router/routes'

const Modules: FC = () => {
  const { t } = useTranslation()

  return (
    <MainLayout>
      <ModulesPageHeader>
        <h2>Módulos</h2>
        <p>Selecciona un módulo para empezar a configurarlo</p>
      </ModulesPageHeader>

      <ModuleSection>
        <ModulesContainer>
          <ModuleCardLink to="/modules/talents">
            <Card>
              <CardIconSection>
                <Icon src={brainImage} alt="Betesa" />
              </CardIconSection>
              <CardDescriptionSection>
                <CardTitle>Betesa</CardTitle>
                <ModuleAction>Ver detalles</ModuleAction>
              </CardDescriptionSection>
            </Card>
          </ModuleCardLink>

          <ModuleCardLink to="/modules/skills">
            <Card>
              <CardIconSection>
                <Icon src={boxImage} alt="3D Skills" />
              </CardIconSection>
              <CardDescriptionSection>
                <CardTitle>{t('global.common.skillText')}</CardTitle>
                <ModuleAction>Ver detalles</ModuleAction>
              </CardDescriptionSection>
            </Card>
          </ModuleCardLink>
        </ModulesContainer>
      </ModuleSection>

      <ModuleSection>
        <SectionTitle>Pre-configuración</SectionTitle>
        <ModulesContainer>
          <ModuleCardLink to={superAdminRoutes.RoleFamily}>
            <Card>
              <CardIconSection>
                <Icon src={Familia} alt="Familia de rol" />
              </CardIconSection>
              <CardDescriptionSection>
                <CardTitle>Familia de rol</CardTitle>
                <ModuleAction>Configurar</ModuleAction>
              </CardDescriptionSection>
            </Card>
          </ModuleCardLink>
        </ModulesContainer>
      </ModuleSection>

      <ModuleSection>
        <SectionTitle>Textos</SectionTitle>
        <ModulesContainer>
          <ModuleCardLink to="/modules/texts/create">
            <Card>
              <CardIconSection>
                <Icon src={Generales} alt="Generales" />
              </CardIconSection>
              <CardDescriptionSection>
                <CardTitle>Generales</CardTitle>
                <ModuleAction>Configurar</ModuleAction>
              </CardDescriptionSection>
            </Card>
          </ModuleCardLink>
        </ModulesContainer>
      </ModuleSection>
    </MainLayout>
  )
}

export default Modules
